import { useEffect } from 'react';

import { QueryResult } from './QueryTypes';

function useDispatchQuery<R, A, T>(query: QueryResult<R>, dispatch: (action: A) => void, type: T): QueryResult<R> {
    useEffect(() => {
        if (query.isSuccess) {
            dispatch({
                type,
                payload: query.data,
            } as unknown as A);
        }
    }, [dispatch, query.data, query.isSuccess, type]);
    return query;
}

export default useDispatchQuery;
